module.exports = new __parcel__URL__("battleroyale_suicides_button.c6dc6402.png").toString();